import bannerImg from '@/assets/bannerImg.png'

export function Discovering() {
  const jumpClientPage = () => {
    const WEBSITE_URL = import.meta.env.VITE_HOME_WEBSITE_URL
    window.open(`${WEBSITE_URL}/download`)
  }
  return (
    <div className='w-full cursor-pointer' onClick={jumpClientPage}>
      <img src={bannerImg} alt='bannerImg' />
    </div>
  )
}
